/* eslint-disable import/no-anonymous-default-export */
import React from 'react';
import store from '../../states/Store';

export default () => 
    <span onClick={() => store.UI.CreateTrade.next(true)}>Create</span>

